var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTypeAddress(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7521 0.999512H4.93256C2.76038 0.999512 0.999512 2.76044 0.999512 4.93262V21.7521C0.999512 23.9243 2.76038 25.6852 4.93256 25.6852H21.7521C23.9243 25.6852 25.6852 23.9243 25.6852 21.7521V4.93262C25.6852 2.76044 23.9243 0.999512 21.7521 0.999512Z",
    stroke: "black",
    strokeWidth: 1.99937,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51817 8.39463C11.6303 6.28252 15.0546 6.28252 17.1667 8.39463C19.2788 10.5067 19.2788 13.9312 17.1667 16.0433L13.3424 19.8676L9.51817 16.0433C7.40605 13.9312 7.40605 10.5067 9.51817 8.39463V8.39463Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3424 14.1968C14.4348 14.1968 15.3205 13.3112 15.3205 12.2188C15.3205 11.1263 14.4348 10.2407 13.3424 10.2407C12.2499 10.2407 11.3643 11.1263 11.3643 12.2188C11.3643 13.3112 12.2499 14.1968 13.3424 14.1968Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.685,
    height: 26.685,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeAddress);
export default __webpack_public_path__ + "static/media/icon_type_address.c457202e6816d8c5d6bc53a57a1b97ad.svg";
export { ForwardRef as ReactComponent };